import { getValidAccessTokenFromStorage } from "./tokenStorage";
import { reportIfWorkspacePaused } from "./workspacePaused";

export class SuiteFetchError extends Error {
  constructor(
    message: string,
    public status: number,
    public details?: unknown
  ) {
    super(message);
    this.name = "SuiteFetchError";
  }
}

export interface FetchWithAuthOptions extends RequestInit {
  skipAuth?: boolean;
}

/**
 * fetch() with Bearer token from shared localStorage (after getValidAccessTokenFromStorage).
 */
export async function fetchWithAuth(
  input: string | URL,
  init: FetchWithAuthOptions = {}
): Promise<Response> {
  const { skipAuth, headers: hdrs, ...rest } = init;
  const headers = new Headers(hdrs);

  if (!skipAuth) {
    const token = await getValidAccessTokenFromStorage();
    if (!token) {
      throw new SuiteFetchError("Not authenticated", 401);
    }
    headers.set("Authorization", `Bearer ${token}`);
  }

  if (!headers.has("Content-Type") && rest.body && !(rest.body instanceof FormData)) {
    headers.set("Content-Type", "application/json");
  }

  const response = await fetch(input, { ...rest, headers });
  // Callers get the response untouched; a paused workspace is reported to the
  // shell from a clone, without delaying them.
  if (!skipAuth && response.status === 403) void reportIfWorkspacePaused(response);
  return response;
}
